import { Box, Button, Container, Typography, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material/styles/createTheme';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths } from 'src/paths';

const { redirectSupervisor } = paths;

const ServerErrorPage = () => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const profileResponse = useSelector((state: any) => state?.getTherapistProfileReducer);
  console.log(profileResponse?.response?.code);
  useEffect(() => {
    if (profileResponse?.response?.code === 'OK') navigate(redirectSupervisor);
  }, []);
  const handleFunc = () => {
    if (profileResponse.response?.code === 'INTERNAL_ERROR') {
      navigate(0);
      return;
    }
    if (profileResponse.response === null && !profileResponse.getAdminProfile) return;
  };
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 6,
            }}
          >
            <Box
              alt="Internal server error"
              component="img"
              src="/assets/errors/error-500.png"
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: 400,
              }}
            />
          </Box>
          <Typography
            align="center"
            variant={mdUp ? 'h1' : 'h4'}
          >
            500: Internal Server Error
          </Typography>
          <Typography
            align="center"
            color="text.secondary"
            sx={{ mt: 0.5 }}
          >
            There was a problem fetching your profile information. Please try again later.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Button
              variant="contained"
              onClick={handleFunc}
            >
              Try Again
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ServerErrorPage;
